import { render, staticRenderFns } from "./QuizCreatorLogSidebar.vue?vue&type=template&id=bea28f78&"
import script from "./QuizCreatorLogSidebar.vue?vue&type=script&lang=js&"
export * from "./QuizCreatorLogSidebar.vue?vue&type=script&lang=js&"
import style0 from "./QuizCreatorLogSidebar.vue?vue&type=style&index=0&id=bea28f78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports